import { MultiSelectOption } from '@/types';

export interface ContactTimelineFilter {
    callType: MultiSelectOption<string> | null;
    sentiment: MultiSelectOption<string> | null;
}
